(function () {
  'use strict';

  function initializeGallery(gallery) {
    if (!gallery || gallery.dataset.thirdPartyGalleryReady === 'true') return;

    var track = gallery.querySelector('[data-third-party-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-third-party-gallery-slide]')) : [];
    var previousButton = gallery.querySelector('[data-third-party-gallery-prev]');
    var nextButton = gallery.querySelector('[data-third-party-gallery-next]');
    var currentLabel = gallery.querySelector('[data-third-party-gallery-current]');

    if (!track || slides.length < 2) return;

    gallery.dataset.thirdPartyGalleryReady = 'true';
    var currentIndex = 0;
    var frameId = 0;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function nearestSlideIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var closestDistance = Infinity;
      var closestIndex = 0;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateCurrent(index) {
      currentIndex = index;
      if (currentLabel) currentLabel.textContent = String(index + 1);
    }

    function moveTo(index) {
      var nextIndex = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slides[nextIndex].offsetLeft,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
      updateCurrent(nextIndex);
    }

    function handleScroll() {
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(function () {
        updateCurrent(nearestSlideIndex());
        frameId = 0;
      });
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        moveTo(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        moveTo(currentIndex + 1);
      });
    }

    track.addEventListener('scroll', handleScroll, { passive: true });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveTo(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveTo(currentIndex + 1);
      }
    });
  }

  function initializeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-third-party-gallery]').forEach(initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
